import { withSvgIconSimple } from './withSvgIconSimple';

export const ChevronRightIcon = withSvgIconSimple(
  <path
    d="M11 8L15 12L11 16"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
